/* eslint-disable no-var, prefer-template, prefer-arrow-callback */
var pubsub = window.DR.pubsub;

function initListingPageFiltering() {
  var filters = $('#search-filters');
  var filtersCats = filters.find('.filters-cat');
  var collapsedCatsInput = document.getElementById('collapsedCats');
  var expFiltersInput = document.getElementById('expandedFilters');
  var collapsedCats = valToArray(collapsedCatsInput);
  var expFilters = valToArray(expFiltersInput);
  var lastCriteriaSelected = $('#lastCriteriaSelected');
  var isReseting = false;
  var $priceMin = $('#price-floor');
  var $priceMax = $('#price-ceiling');

  // Disable HTML5 validation
  filters.attr('novalidate', '');

  // Attach price restriction to change event on price inputs
  filters.find('#price-slider input[type="number"]').change(function onChange() {
    restrictPriceRange();
  });

  /**
   * Restrict user to input negative price or input min price greater then max price
   * @returns {void}
   */
  function restrictPriceRange() {
    var min = parseInt($priceMin.val(), 10);
    var max = parseInt($priceMax.val(), 10);

    min = min < 0 ? 0 : min;
    max = max < 0 ? 0 : max;
    max = min > max ? min : max;

    $priceMin.val(min);
    $priceMax.val(max);
  }

  function valToArray(input) {
    if (!input.value) {
      return [];
    }
    return input.value.split(',');
  }

  function setCollapsed(cat, id) {
    cat.addClass('collapsed');
    collapsedCats.push(id);
    collapsedCatsInput.value = collapsedCats.join(',');
  }

  function unsetCollapsed(cat, id) {
    cat.removeClass('collapsed');
    for (var i = 0; i < collapsedCats.length; i++) {
      if (id === parseInt(collapsedCats[i], 10)) {
        collapsedCats.splice(i, 1);
      }

    }
    collapsedCatsInput.value = collapsedCats.join(',');
  }

  function updateExpFilters() {
    var id;
    var cat;

    for (var i = 0; i < expFilters.length; i++) {
      id = expFilters[i];
      cat = $(filtersCats[id]);
      cat.removeClass('filters-collapsed');
    }
  }

  function updateCollapsedCats() {
    var id;

    for (var i = 0; i < collapsedCats.length; i++) {
      id = collapsedCats[i];
      $(filtersCats[id]).addClass('collapsed');
    }
  }

  // Replace links with a data-for attribute with proper label
  filters.find('a[data-for]').each(function each() {
    var inner = this.innerHTML;
    var forAttr = this.getAttribute('data-for');
    this.outerHTML = '<label for="' + forAttr + '">' + inner + '</label>';
  });

  // Please drop the click event with the IE8 support
  filters.find('input[type=checkbox]').bind('change click', function onChangeOrClick() {
    if (!isReseting) {
      filters[0].submit();
    }
  });

  filters.find('.btn-reset').click(function onClick(e) {
    var selectedValue;
    var inputs = filters.find('.filters-cat input');
    $('input[name=\'reset\']').val('true');

    isReseting = true;

    $(inputs).each(function each(i, input) {
      if (input.checked) {
        input.removeAttribute('checked');
      }
      if (input.getAttribute('type') === 'text' ||
        input.getAttribute('type') === 'number') {
        input.setAttribute('value', '');
      }
      if (i === inputs.length - 1) {
        isReseting = false;
        selectedValue = input.getAttribute('name') + '-' + input.value;
        lastCriteriaSelected.val(selectedValue);
        filters[0].submit();
      }
    });

    $(this).closest('form').submit();
  });

  filtersCats.each(function each(index, category) {
    var cat = $(category);
    var header = cat.find('.header');

    // Toggle for cat
    header.click(function onClick(e) {
      var expand = cat.hasClass('collapsed');
      var toggleFn = expand ? unsetCollapsed : setCollapsed;
      toggleFn(cat, index);
      pubsub.emit('togglecat', cat, expand);
    });
  });

  updateExpFilters();
  updateCollapsedCats();
}

module.exports = {
  initListingPageFiltering
};
